import React from 'react'
import { useDispatch } from 'react-redux'
import { useMount } from 'react-nb-hooks'
import LKGrid, { destroy } from 'shared/LKGrid'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
import styled from 'styled-components'
import { translate as mainTranslate } from 'loankeeper-common/helpers'
import { loanView } from '../../../../store/loan'
import LKModal, { actions as LKModalActions, LKModalContainer } from 'shared/LKModal'

const translateRefin = (key) => mainTranslate(`frm_loan_refin_list-${key}`)

const GridWrapper = styled.div`
  height: 480px;
`

const instanceName = 'refinList'
const REFIN_LIST_MODAL = 'refin-List-modal'

const config = {
  instanceName,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: false,
  syncGridState: true,
  enableRowSelection: true,
  enableSorting: true,

  gridIdentity: {
    formName: 'frm_loan_refin_list',
    objectName: 'dbgrd_loanrefinlist',
  },

  columnConfigs: {
    RefinDate: { valueFormatter: ({ value }) => dateFormatter(value) },
  },
}

const RefinListModal = (props) => {
  const [data, setData] = React.useState([])
  const dispatch = useDispatch()

  const fetchRefinlist = async () => {
    try {
      const result = await dispatch(
        loanView({
          page: 'refinlist',
          LoanID: props.params.LoanID,
          HashSum_LoanID_: props.params.HashSum_LoanID_,
        }),
      )

      if (loanView.fulfilled.match(result)) {
        const Data = result.payload
        setData(Data)
      }
    } catch (err) {
      dispatch(LKModalActions.openError(err.Error.Message || err.Error.Text))
    }
  }

  useMount(() => {
    fetchRefinlist()
  })

  const handleCloseModal = () => {
    dispatch(destroy(instanceName))
    props.closeModal()
  }

  return (
    <LKModal
      size="sm-3"
      name={props.modalInstanceName}
      heading={translateRefin('frm_loan_refin_list')}
      footer={
        <LKModal.Footer
          sideActions={<LKModal.CancelButton onClick={handleCloseModal} text={translateRefin('cmd_close')} />}
        />
      }
    >
      <GridWrapper>
        <LKGrid {...config} rowData={data} />
      </GridWrapper>
    </LKModal>
  )
}

export const openRefinModal = (ID, hash) =>
  LKModalActions.open({
    name: REFIN_LIST_MODAL,
    LoanID: ID,
    HashSum_LoanID_: hash,
  })

export default LKModalContainer(REFIN_LIST_MODAL)(RefinListModal)
